// extracted by css-extract-rspack-plugin
export default {"BehaviorOptionIcon":"TypeSelector-module__BehaviorOptionIcon___Rli2l","Icon":"TypeSelector-module__Icon___z33Ty","isSelected":"TypeSelector-module__isSelected___xz_a0"};